import React from 'react';
import _ from 'lodash';

import * as util from '#packages/util';
import styles from './mobileFrameComponent.scss';

interface MobileFrameComponentProps {
  frameStyle?: any;
  className?: string;
  frameless?: boolean;
  previewMode?: boolean;
  noShadow?: boolean;
  onMobileDeviceBtnClick?: (event: any) => void;
  shouldRenderFixedStageTopGap: boolean;
  isMobileWizardPreviewFrameVisible: boolean;
}

interface MobileFrameVerticalScrollWrapperProps {
  withShadowExtraSpace?: boolean;
  withFrameExtraSpace?: boolean;
  shouldRenderFixedStageTopGap: boolean;
  isMobileWizardPreviewFrameVisible: boolean;
  children?: React.ReactNode;
}

const MobileFrameVerticalScrollWrapper: React.FC<
  MobileFrameVerticalScrollWrapperProps
> = (props) => {
  const className = util.cx({
    [styles.mobileFrameScrollWrapper]: true,
    [styles.withShadowExtraSpace]: props.withShadowExtraSpace,
    [styles.withFrameExtraSpace]: props.withFrameExtraSpace,
  });

  return (
    <div className={className}>
      <div
        className={util.cx(styles.mobileFrameScrollContainer, {
          [styles.mobileFrameScrollContainerFixedMarginTop]:
            props.shouldRenderFixedStageTopGap,
          [styles.mobileFrameScrollContainerWizardPreview]:
            props.isMobileWizardPreviewFrameVisible,
        })}
      >
        {props.children}
      </div>
      <div
        className={util.cx(styles.mobileFrameScrollCover, {
          [styles.mobileFrameScrollCoverFixedMarginTop]:
            props.shouldRenderFixedStageTopGap,
          [styles.mobileFrameScrollCoverWizardPreview]:
            props.isMobileWizardPreviewFrameVisible,
        })}
      />
    </div>
  );
};

export const MobileFrameComponent = React.forwardRef<
  HTMLDivElement,
  MobileFrameComponentProps
>((props, ref) => {
  const withoutCustomStyle = _.isEmpty(props.frameStyle);

  return (
    <MobileFrameVerticalScrollWrapper
      withShadowExtraSpace={withoutCustomStyle}
      withFrameExtraSpace={withoutCustomStyle && !props.frameless}
      shouldRenderFixedStageTopGap={props.shouldRenderFixedStageTopGap}
      isMobileWizardPreviewFrameVisible={
        props.isMobileWizardPreviewFrameVisible
      }
    >
      <div
        style={props.frameStyle}
        className={util.cx(styles.mobileFrame, {
          [styles.previewMode]: props.previewMode,
          [styles.frameless]: props.frameless,
        })}
        ref={ref}
      >
        <div className={styles.mobileFrameTop} />
        {props.noShadow ? null : (
          <div
            className={util.cx(styles.siteShadow, {
              [styles.siteShadowSectionsExperience]:
                util.sections.isSectionsEnabled(),
            })}
          />
        )}
        <div
          onClick={props.onMobileDeviceBtnClick}
          className={styles.mobileFrameBottom}
          data-aid={'mobile-frame-bottom'}
        />
      </div>
    </MobileFrameVerticalScrollWrapper>
  );
});

MobileFrameComponent.displayName = 'MobileFrameComponent';
